import React, { useEffect, useState, useContext } from 'react';
import { connect } from 'react-redux';
import {
	Row,
	Col,
	Card,
	Result,
	Input,
	Divider,
	Typography,
	notification,
	Button,
	Space,
} from 'antd';

import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XThemeInputText,
	XThemeRadio,
	XThemeNextPrevBtn,
} from '../../styles/GlobalThemeStyle';
// actions

import {
	editPayerConfigurationApi,
	editPayerConfigurationReset,
} from '../../actions/editPayerConfigurationAction';

import { checkModulePermissions, truncateString } from '../../utils/helper';
import { dateFilters } from '../../utils/constants';
import HeaderFile from '../../components/Header/HeaderFile';
import DataTable from '../../components/DataTable/DataTable';
import Header from '../../components/Header/Header';
import { filterByLabel } from '../../utils/formFunctions';
import { FormDataContext } from './PayerConfigurationForm';
import { XTheme2Button } from '../../styles/GlobalThemeStyleCQ';
const { Text, Link } = Typography;

const Step2 = (props) => {
	const {
		editPayerConfiguration,
		editPayerConfigurationReset,
		editPayerConfigurationState,
	} = props;

	const { form, formDataState, currentState, editModeState } =
		useContext(FormDataContext);

	useEffect(() => {
		if (editPayerConfigurationState.apiState == 'success') {
			// currentState.setCurrent((old)=>{
			//     return old+1;
			// });

			notification.success({
				message: editPayerConfigurationState.message,
			});
			editPayerConfigurationReset();
		}
	}, [editPayerConfigurationState]);

	const handlePrev = () => {
		currentState.setCurrent((old) => {
			return old - 1;
		});
	};

	const handleNext = () => {
		form.validateFields([
			'pre_service-rc-organization_determination-timeline',
			'pre_service-rc-organization_determination-timeline_type',
			'pre_service-rc-organization_determination-in_process',
			'pre_service-rc-organization_determination-at_risk',
			'pre_service-rc-organization_determination-escalation',
			'pre_service-rc-organization_determination-untimely',
			'pre_service-rc-first_appeal-timeline',
			'pre_service-rc-first_appeal-timeline_type',
			'pre_service-rc-first_appeal-in_process',
			'pre_service-rc-first_appeal-at_risk',
			'pre_service-rc-first_appeal-escalation',
			'pre_service-rc-first_appeal-untimely',
			'pre_service-rc-second_appeal-timeline',
			'pre_service-rc-second_appeal-timeline_type',
			'pre_service-rc-second_appeal-in_process',
			'pre_service-rc-second_appeal-at_risk',
			'pre_service-rc-second_appeal-escalation',
			'pre_service-rc-second_appeal-untimely',
			'pre_service-rc-third_appeal-timeline',
			'pre_service-rc-third_appeal-timeline_type',
			'pre_service-rc-third_appeal-in_process',
			'pre_service-rc-third_appeal-at_risk',
			'pre_service-rc-third_appeal-escalation',
			'pre_service-rc-third_appeal-untimely',
			'pre_service-rc-fourth_appeal-timeline',
			'pre_service-rc-fourth_appeal-timeline_type',
			'pre_service-rc-fourth_appeal-in_process',
			'pre_service-rc-fourth_appeal-at_risk',
			'pre_service-rc-fourth_appeal-escalation',
			'pre_service-rc-fourth_appeal-untimely',
			'pre_service-rc-judicial_review-timeline',
			'pre_service-rc-judicial_review-timeline_type',
			'pre_service-rc-judicial_review-in_process',
			'pre_service-rc-judicial_review-at_risk',
			'pre_service-rc-judicial_review-escalation',
			'pre_service-rc-judicial_review-untimely',
			'pre_service-ma_standard-organization_determination-timeline',
			'pre_service-ma_standard-organization_determination-timeline_type',
			'pre_service-ma_standard-organization_determination-in_process',
			'pre_service-ma_standard-organization_determination-at_risk',
			'pre_service-ma_standard-organization_determination-untimely',
			'pre_service-ma_standard-first_appeal-timeline',
			'pre_service-ma_standard-first_appeal-timeline_type',
			'pre_service-ma_standard-first_appeal-in_process',
			'pre_service-ma_standard-first_appeal-at_risk',
			'pre_service-ma_standard-first_appeal-untimely',
			'pre_service-ma_standard-second_appeal-timeline',
			'pre_service-ma_standard-second_appeal-timeline_type',
			'pre_service-ma_standard-second_appeal-in_process',
			'pre_service-ma_standard-second_appeal-at_risk',
			'pre_service-ma_standard-second_appeal-untimely',
			'pre_service-ma_standard-third_appeal-timeline',
			'pre_service-ma_standard-third_appeal-timeline_type',
			'pre_service-ma_standard-third_appeal-in_process',
			'pre_service-ma_standard-third_appeal-at_risk',
			'pre_service-ma_standard-third_appeal-untimely',
			'pre_service-ma_standard-fourth_appeal-timeline',
			'pre_service-ma_standard-fourth_appeal-timeline_type',
			'pre_service-ma_standard-fourth_appeal-in_process',
			'pre_service-ma_standard-fourth_appeal-at_risk',
			'pre_service-ma_standard-fourth_appeal-untimely',
			'pre_service-ma_standard-judicial_review-timeline',
			'pre_service-ma_standard-judicial_review-timeline_type',
			'pre_service-ma_standard-judicial_review-in_process',
			'pre_service-ma_standard-judicial_review-at_risk',
			'pre_service-ma_standard-judicial_review-untimely',
		])
			.then((values) => {
				formDataState.setFormData((old) => {
					return { ...old, ...values };
				});
				currentState.setCurrent((old) => {
					return old + 1;
				});
			})
			.catch((error) => {
				return;
			});
	};

	const handleUpdate = () => {
		form.validateFields([
			'pre_service-rc-organization_determination-timeline',
			'pre_service-rc-organization_determination-timeline_type',
			'pre_service-rc-organization_determination-in_process',
			'pre_service-rc-organization_determination-at_risk',
			'pre_service-rc-organization_determination-escalation',
			'pre_service-rc-organization_determination-untimely',
			'pre_service-rc-first_appeal-timeline',
			'pre_service-rc-first_appeal-timeline_type',
			'pre_service-rc-first_appeal-in_process',
			'pre_service-rc-first_appeal-at_risk',
			'pre_service-rc-first_appeal-escalation',
			'pre_service-rc-first_appeal-untimely',
			'pre_service-rc-second_appeal-timeline',
			'pre_service-rc-second_appeal-timeline_type',
			'pre_service-rc-second_appeal-in_process',
			'pre_service-rc-second_appeal-at_risk',
			'pre_service-rc-second_appeal-escalation',
			'pre_service-rc-second_appeal-untimely',
			'pre_service-rc-third_appeal-timeline',
			'pre_service-rc-third_appeal-timeline_type',
			'pre_service-rc-third_appeal-in_process',
			'pre_service-rc-third_appeal-at_risk',
			'pre_service-rc-third_appeal-escalation',
			'pre_service-rc-third_appeal-untimely',
			'pre_service-rc-fourth_appeal-timeline',
			'pre_service-rc-fourth_appeal-timeline_type',
			'pre_service-rc-fourth_appeal-in_process',
			'pre_service-rc-fourth_appeal-at_risk',
			'pre_service-rc-fourth_appeal-escalation',
			'pre_service-rc-fourth_appeal-untimely',
			'pre_service-rc-judicial_review-timeline',
			'pre_service-rc-judicial_review-timeline_type',
			'pre_service-rc-judicial_review-in_process',
			'pre_service-rc-judicial_review-at_risk',
			'pre_service-rc-judicial_review-escalation',
			'pre_service-rc-judicial_review-untimely',
			'pre_service-ma_standard-organization_determination-timeline',
			'pre_service-ma_standard-organization_determination-timeline_type',
			'pre_service-ma_standard-organization_determination-in_process',
			'pre_service-ma_standard-organization_determination-at_risk',
			'pre_service-ma_standard-organization_determination-untimely',
			'pre_service-ma_standard-first_appeal-timeline',
			'pre_service-ma_standard-first_appeal-timeline_type',
			'pre_service-ma_standard-first_appeal-in_process',
			'pre_service-ma_standard-first_appeal-at_risk',
			'pre_service-ma_standard-first_appeal-untimely',
			'pre_service-ma_standard-second_appeal-timeline',
			'pre_service-ma_standard-second_appeal-timeline_type',
			'pre_service-ma_standard-second_appeal-in_process',
			'pre_service-ma_standard-second_appeal-at_risk',
			'pre_service-ma_standard-second_appeal-untimely',
			'pre_service-ma_standard-third_appeal-timeline',
			'pre_service-ma_standard-third_appeal-timeline_type',
			'pre_service-ma_standard-third_appeal-in_process',
			'pre_service-ma_standard-third_appeal-at_risk',
			'pre_service-ma_standard-third_appeal-untimely',
			'pre_service-ma_standard-fourth_appeal-timeline',
			'pre_service-ma_standard-fourth_appeal-timeline_type',
			'pre_service-ma_standard-fourth_appeal-in_process',
			'pre_service-ma_standard-fourth_appeal-at_risk',
			'pre_service-ma_standard-fourth_appeal-untimely',
			'pre_service-ma_standard-judicial_review-timeline',
			'pre_service-ma_standard-judicial_review-timeline_type',
			'pre_service-ma_standard-judicial_review-in_process',
			'pre_service-ma_standard-judicial_review-at_risk',
			'pre_service-ma_standard-judicial_review-untimely',
		])
			.then((values) => {
				formDataState.setFormData((old) => {
					return { ...old, ...values };
				});

				editPayerConfiguration({
					update_type: 'pre_service',
					id: formDataState.formData.id,
					...values,
				});
			})
			.catch((error) => {
				return;
			});
	};

	return (
		<>
			<XThemeForm
				form={form}
				name="timelineConfigFrom"
				layout="vertical"
				autoComplete="off"
			>
				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<p className="modalPara1 text-dark m-0">
							<strong>RC</strong>
						</p>
					</Col>
				</Row>
				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Organization Determination</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-organization_determination-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="pre_service-rc-organization_determination-timeline"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-organization_determination-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-organization_determination-in_process"
							label="In Process"
							rules={[
								{
									required: true,
									message: 'Please enter In process start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Process Start"
								name="pre_service-rc-organization_determination-in_process"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-organization_determination-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="pre_service-rc-organization_determination-at_risk"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-organization_determination-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="pre_service-rc-organization_determination-escalation"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-organization_determination-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="pre_service-rc-organization_determination-untimely"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>First Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-first_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="pre_service-rc-first_appeal-timeline"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-first_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-first_appeal-in_process"
							label="In Process"
							rules={[
								{
									required: true,
									message: 'Please enter In process start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Process Start"
								name="pre_service-rc-first_appeal-in_process"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-first_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="pre_service-rc-first_appeal-at_risk"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-first_appeal-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="pre_service-rc-first_appeal-escalation"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-first_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="pre_service-rc-first_appeal-untimely"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Second Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-second_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="pre_service-rc-second_appeal-timeline"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-second_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-second_appeal-in_process"
							label="In Process"
							rules={[
								{
									required: true,
									message: 'Please enter In process start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Process Start"
								name="pre_service-rc-second_appeal-in_process"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-second_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="pre_service-rc-second_appeal-at_risk"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-second_appeal-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="pre_service-rc-second_appeal-escalation"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-second_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="pre_service-rc-second_appeal-untimely"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Third Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-third_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="pre_service-rc-third_appeal-timeline"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-third_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-third_appeal-in_process"
							label="In Process"
							rules={[
								{
									required: true,
									message: 'Please enter In process start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Process Start"
								name="pre_service-rc-third_appeal-in_process"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-third_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="pre_service-rc-third_appeal-at_risk"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-third_appeal-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="pre_service-rc-third_appeal-escalation"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-third_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="pre_service-rc-third_appeal-untimely"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Fourth Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-fourth_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="pre_service-rc-fourth_appeal-timeline"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-fourth_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-fourth_appeal-in_process"
							label="In Process"
							rules={[
								{
									required: true,
									message: 'Please enter In process start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Process Start"
								name="pre_service-rc-fourth_appeal-in_process"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-fourth_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="pre_service-rc-fourth_appeal-at_risk"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-fourth_appeal-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="pre_service-rc-fourth_appeal-escalation"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-fourth_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="pre_service-rc-fourth_appeal-untimely"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Judicial Review</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-judicial_review-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="pre_service-rc-judicial_review-timeline"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-judicial_review-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-judicial_review-in_process"
							label="In Process"
							rules={[
								{
									required: true,
									message: 'Please enter In process start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Process Start"
								name="pre_service-rc-judicial_review-in_process"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-judicial_review-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="pre_service-rc-judicial_review-at_risk"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-judicial_review-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="pre_service-rc-judicial_review-escalation"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-rc-judicial_review-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="pre_service-rc-judicial_review-untimely"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 30)} className="mt-4">
					<Col xs={24}>
						<p className="modalPara1 text-dark m-0">
							<strong>MA Standard</strong>
						</p>
					</Col>
				</Row>
				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Organization Determination</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-organization_determination-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="pre_service-ma_standard-organization_determination-timeline"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-organization_determination-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-organization_determination-in_process"
							label="In Process"
							rules={[
								{
									required: true,
									message: 'Please enter In process start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Process Start"
								name="pre_service-ma_standard-organization_determination-in_process"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-organization_determination-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="pre_service-ma_standard-organization_determination-at_risk"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-organization_determination-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="pre_service-ma_standard-organization_determination-untimely"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>
				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>First Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-first_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="pre_service-ma_standard-first_appeal-timeline"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-first_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-first_appeal-in_process"
							label="In Process"
							rules={[
								{
									required: true,
									message: 'Please enter In process start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Process Start"
								name="pre_service-ma_standard-first_appeal-in_process"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-first_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="pre_service-ma_standard-first_appeal-at_risk"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-first_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="pre_service-ma_standard-first_appeal-untimely"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Second Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-second_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="pre_service-ma_standard-second_appeal-timeline"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-second_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-second_appeal-in_process"
							label="In Process"
							rules={[
								{
									required: true,
									message: 'Please enter In process start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Process Start"
								name="pre_service-ma_standard-second_appeal-in_process"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-second_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="pre_service-ma_standard-second_appeal-at_risk"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-second_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="pre_service-ma_standard-second_appeal-untimely"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Third Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-third_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="pre_service-ma_standard-third_appeal-timeline"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-third_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-third_appeal-in_process"
							label="In Process"
							rules={[
								{
									required: true,
									message: 'Please enter In process start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Process Start"
								name="pre_service-ma_standard-third_appeal-in_process"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-third_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="pre_service-ma_standard-third_appeal-at_risk"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-third_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="pre_service-ma_standard-third_appeal-untimely"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Fourth Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-fourth_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="pre_service-ma_standard-fourth_appeal-timeline"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-fourth_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-fourth_appeal-in_process"
							label="In Process"
							rules={[
								{
									required: true,
									message: 'Please enter In process start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Process Start"
								name="pre_service-ma_standard-fourth_appeal-in_process"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-fourth_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="pre_service-ma_standard-fourth_appeal-at_risk"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-fourth_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="pre_service-ma_standard-fourth_appeal-untimely"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Judicial Review</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-judicial_review-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="pre_service-ma_standard-judicial_review-timeline"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-judicial_review-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-judicial_review-in_process"
							label="In Process"
							rules={[
								{
									required: true,
									message: 'Please enter In process start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Process Start"
								name="pre_service-ma_standard-judicial_review-in_process"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-judicial_review-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="pre_service-ma_standard-judicial_review-at_risk"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="pre_service-ma_standard-judicial_review-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="pre_service-ma_standard-judicial_review-untimely"
								type="number"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={[15, 15]} className="align-items-center">
					{editModeState.editMode ? (
						<Col xs={24} className="text-center text-md-end">
							<Space>
								<XTheme2Button
									className="noBackground"
									onClick={handlePrev}
								>
									<LeftOutlined />
									Previous
								</XTheme2Button>
								<XTheme2Button onClick={handleNext}>
									Next
									<RightOutlined />
								</XTheme2Button>
								<Divider
									type="vertical"
									style={{
										height: '30px',
										marginInline: '20px',
									}}
									orientationMargin={1}
								/>
								<XTheme2Button onClick={handleUpdate}>
									Update
								</XTheme2Button>
							</Space>
						</Col>
					) : (
						<Col xs={24} className="text-end text-md-end">
							<Space>
								<XTheme2Button
									className="noBackground"
									onClick={handlePrev}
								>
									<LeftOutlined />
									Previous
								</XTheme2Button>

								<XTheme2Button onClick={handleNext}>
									Next
									<RightOutlined />
								</XTheme2Button>
							</Space>
						</Col>
					)}
				</Row>
			</XThemeForm>
		</>
	);
};

const mapStateToProps = (state) => ({
	editPayerConfigurationState: state.editPayerConfiguration,
});

const mapDispatchToProps = (dispatch) => ({
	editPayerConfiguration: (data) => dispatch(editPayerConfigurationApi(data)),
	editPayerConfigurationReset: () => dispatch(editPayerConfigurationReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Step2);
